module.exports = __webpack_public_path__ + "img/icon_per_video.6ce88320.svg";